export interface IOperator {
  id: number;
  name: string;
}

export const TEZ_OPERATOR: IOperator = { id: 10, name: "TezTour" };
